import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { formatDateToParts } from '../../util/DateUtil';
import { useAemConfig } from '@as-react/common-components';
const OpeningHour = ({ date, openingHour, closingHour, closed, locale, closedText }) => {
    const { weekday, day, month } = formatDateToParts(date, locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
    });
    return (_jsxs(_Fragment, { children: [_jsxs(TextAlpha, { children: [weekday, ' ', _jsx(TextAlpha, { variant: "bodyXS", as: "span", children: `${day} ${month}` })] }), _jsx(TextAlpha, { children: closed ? closedText : `${openingHour} - ${closingHour}` })] }));
};
export const OpeningHours = ({ openingHours }) => {
    const { locale } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.store);
    return (_jsx(Grid, { columns: "auto-1fr", gapX: "10", gapY: "0", children: openingHours.map(openingHour => (_jsx(OpeningHour, Object.assign({}, openingHour, { locale: locale, closedText: t('store.closed.txt') }), openingHour.date))) }));
};
